import { supabase } from '@/integrations/supabase/client';
import { User } from '@/types/user';

/**
 * Serviço para gerenciar usuários
 */
class UserService {
  /**
   * Obtém o usuário atual do Supabase
   */
  async getCurrentUser(): Promise<User | null> {
    try {
      console.log('Fetching current auth user...');
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        console.log('No auth user found');
        return null;
      }
      
      console.log('Auth user found:', user.id);
      
      // Buscar dados adicionais na tabela subscriptions
      console.log('Fetching subscription for user_id:', user.id);
      const { data: subscription, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', user.id)
        .single();
      
      if (error) {
        console.log('Error fetching subscription:', error);
        
        // Se não encontrarmos uma subscription, retornamos apenas o usuário básico
        return {
          id: user.id,
          email: user.email,
          name: user.email?.split('@')[0] || 'Usuário',
          avatar_url: null
        };
      }
      
      console.log('Subscription found:', subscription);
      console.log('Subscription ID:', subscription.id);
      console.log('Subscription user_id:', subscription.user_id);
      
      // Para debug, verificar o que está vindo no objeto subscription
      const subscriptionKeys = Object.keys(subscription);
      console.log('Subscription object keys:', subscriptionKeys);
      
      const userData = {
        id: user.id, // Importante: este é o ID do AUTH USER, não da subscription
        email: user.email,
        name: user.email?.split('@')[0] || 'Usuário',
        avatar_url: null,
        // Adicionar dados da subscription
        subscription_status: subscription.status,
        subscription_id: subscription.id,
        plan: subscription.plan
      };
      
      console.log('Returning user data with ID:', userData.id);
      return userData;
    } catch (error) {
      console.error('Error in getCurrentUser:', error);
      return null;
    }
  }
  
  /**
   * Obtém um usuário pelo ID
   */
  async getUserById(userId: string): Promise<User | null> {
    try {
      console.log('Fetching user by ID:', userId);
      
      // Buscar na tabela subscriptions
      const { data: subscription, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', userId)
        .single();
      
      if (error) {
        console.warn('No subscription found for user:', error);
        return {
          id: userId,
          name: 'Usuário',
          email: null
        };
      }
      
      console.log('Subscription found for user:', subscription);
      
      return {
        id: userId, // Este é o ID do usuário, não a subscription
        name: 'Usuário',
        email: null,
        subscription_status: subscription.status,
        subscription_id: subscription.id,
        plan: subscription.plan
      };
    } catch (error) {
      console.error('Error in getUserById:', error);
      return null;
    }
  }
  
  /**
   * Atualiza o perfil do usuário
   */
  async updateUserProfile(userId: string, profileData: Partial<User>): Promise<User | null> {
    console.log('Updating user profile for ID:', userId);
    console.log('Profile data:', profileData);
    
    // Esta função está incompleta pois não temos uma tabela de perfis
    // Apenas retorna os dados recebidos
    return {
      id: userId,
      ...profileData
    } as User;
  }
}

export const userService = new UserService(); 